import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Item = styled(Grid)<{ selected?: boolean }>(
  {
    width: "100%",
    display: "flex",
    borderBottom: "1px solid grey",
    marginBottom: "5px",
    padding: "5px 0",
    justifyContent: "space-between",
    cursor: "pointer",

    "& div": {
      display: "flex",
    },
    "& span:nth-of-type(1)": {
      width: "40%",
    },
    "& span:nth-of-type(2)": {
      width: "35%",
    },
    "& span:nth-of-type(3)": {
      width: "15%",
    },
  },
  ({ selected }) => ({
    ...(selected && { backgroundColor: "rgba(140, 182, 250, 0.2)" }),
  })
);

export const SelectedBlock = styled(Grid)({
  margin: "10px 0",
});

export const ResetButtonContainer = styled(Grid)({
  width: "100%",
  marginTop: "10px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
});
